module.exports = __webpack_public_path__ + "media/images/cleanness-e1e22214e478bb51b8a96705b231b827.png";